import { useContext, useEffect } from 'react';
import type { ReactNode } from 'react';
import { MessageGenerationSocketEvent } from '@trinity/chat';
import type { MessageGenState } from '@trinity/chat';
import { useMessageGenerationSocket } from '@trinity/chat-components/websocket/hooks/useMessageGenerationSocket.js';
import { MessageGenerationDispatchContext, MessageGenerationStateContext } from './Context';

interface Props {
  children: ReactNode;
}

export const MessageGenerationWebSocketContainer = ({ children }: Props): ReactNode => {
  const session = useContext(MessageGenerationStateContext);
  const socket = useMessageGenerationSocket(session?.id || undefined);
  const dispatch = useContext(MessageGenerationDispatchContext);

  useEffect(() => {
    if (!socket || !dispatch) return;

    const handleSnapshotUpdated = (payload: MessageGenState) => {
      console.log('Received message generation state snapshot update from WebSocket:', payload);
      dispatch(payload);
    };

    socket.on(MessageGenerationSocketEvent.StateSnapshotUpdated, handleSnapshotUpdated);

    return () => {
      socket.off(MessageGenerationSocketEvent.StateSnapshotUpdated, handleSnapshotUpdated);
    };
  }, [socket, dispatch]);

  return <>{children}</>;
};
